export default __webpack_public_path__ + "assets/online-ordering-overview.2cab1430.svg";